<template>
    <v-container fill-height fluid id="actions" style="border-top: solid 1px #dcdcdc; overflow: hidden;">
        <v-row style="align-content: space-evenly;">
            <v-col class="justify-start pl-8 d-flex col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                <v-btn raised fab @click="prevStep" class="elevation-5" v-bind:class="buttonClass">
                    <v-icon style="font-size: 40px;">mdi-chevron-left</v-icon>
                </v-btn>
            </v-col>
            <v-col class="justify-center d-md-flex d-lg-flex d-xl-flex d-none d-xs-none d-sm-none col-md-8 col-lg-8 col-xl-8">
                <v-stepper v-model="currentStep" alt-labels style="width: 100%; box-shadow: none;" v-if="isWalkin && !isEzyvetFacility">
                    <v-stepper-header style="max-height: 85px; border: none; box-shadow: none;">
                        <v-stepper-step step="1" :complete="currentStep > 1">
                            {{ secondStep === 'patientDemographics' ? 'Pet Info' : 'Patient Info' }}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2" :complete="currentStep > 2" v-if="secondStep">
                            {{ secondStep === 'patientDemographics' ? 'Owner Info' : (secondStep === 'chiefComplaint' || secondStep === 'clientDepartments' ? 'Visit Info' : 'Visit Questions') }}
                        </v-stepper-step>
                        <v-divider v-if="secondStep"></v-divider>
                        <v-stepper-step step="3" :complete="currentStep > 3" v-if="thirdStep">
                            {{ secondStep === 'patientDemographics' && (thirdStep === 'chiefComplaint' || thirdStep === 'clientDepartments') ? 'Visit Info' : 'Visit Questions' }}
                        </v-stepper-step>
                        <v-divider v-if="thirdStep"></v-divider>
                        <v-stepper-step step="4" :complete="currentStep > 4" v-if="fourthStep">
                            Visit Questions
                        </v-stepper-step>
                        <v-divider v-if="thirdStep"></v-divider>
                        <v-stepper-step :step="lastStep">
                            Contact Info
                        </v-stepper-step>
                    </v-stepper-header>
                </v-stepper>
                <v-stepper v-model="currentStep" alt-labels style="width: 100%; box-shadow: none;" v-if="isWalkin && isEzyvetFacility">
                    <v-stepper-header style="max-height: 85px; border: none; box-shadow: none;">
                        <v-stepper-step step="1" :complete="currentStep > 1">
                            Owner Contact Info
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2" :complete="currentStep > 2" v-if="secondStep">
                            Owner Info
                        </v-stepper-step>
                        <v-divider v-if="secondStep"></v-divider>
                        <v-stepper-step step="3" :complete="currentStep > 3" v-if="thirdStep">
                            Pet Info
                        </v-stepper-step>
                        <v-divider v-if="thirdStep"></v-divider>
                        <v-stepper-step step="4" :complete="currentStep > 4" v-if="fourthStep">
                            Visit Questions
                        </v-stepper-step>
                        <v-divider v-if="fourthStep"></v-divider>
                        <v-stepper-step :step="lastStep">
                            Visit Info
                        </v-stepper-step>
                    </v-stepper-header>
                </v-stepper>
            </v-col>
            <v-col class="justify-center text-center d-xs-flex d-sm-flex d-md-none d-lg-none d-xl-none col-sm-6 col-xs-6" style="align-self: center" v-if="isWalkin || isOnline">
                <span style="font-size: 18px;"><strong>{{ currentStep }}</strong> / {{ lastStep }}</span>
            </v-col>
            <v-col class="justify-end d-flex pr-8 col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">                
                <v-btn v-if="currentStep !== lastStep"
                       raised
                       fab
                       @click="nextStep"
                       :disabled="nextStepDisabled"
                       color="secondary"
                       class="elevation-5"
                       v-bind:class="buttonClass">
                    <v-icon style="font-size:40px;">mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn v-else
                       @click="completeRegistration"
                       :disabled="nextStepDisabled"
                       color="secondary"
                       class="elevation-5"
                       large
                       raised
                       style="font-size: 16px; font-weight: 700;">
                    {{ currentModel.settings.localizedContent['reservation_submit_label'] }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    /* eslint-disable no-unreachable */
    /* eslint-disable no-useless-escape*/
    import moment from 'moment';
    import ContextualMixin from '../mixins/contextualMixin'
    import WalkinFormMixin from '../mixins/walkinFormMixin'
    export default {
        name: 'Actions',
        mixins: [ContextualMixin, WalkinFormMixin],
        computed: {
            demographicFormIsValid() {
                return this.currentDemographic.isValid
                    && (!this.currentModel.settings.useDateDobInputType || this.currentDemographic.formData.dob)
                    && (!this.currentModel.settings.useApproxAgeDobInputType || this.currentDemographic.formData.approxAge)
                    && (!this.currentModel.settings.showPatientGender || this.currentDemographic.formData.sex);
            },
            petDemographicFormIsValid() {
                return this.currentPetDemographic.isValid
                    && (!this.currentModel.settings.walkInShowPetName || (this.currentPetDemographic.formData.petName && this.currentPetDemographic.formData.petName.length))
                    && (!this.currentModel.settings.ShowWalkInPetColor || (this.currentPetDemographic.formData.petColor && this.currentPetDemographic.formData.petColor.length))
                    && (!this.currentModel.settings.showWalkInPetSpeciesGeneral || (this.currentPetDemographic.formData.species && this.currentPetDemographic.formData.species.length))
                    && (this.isEzyvetFacility || (!this.currentModel.settings.showWalkInPetSubSpecies || (this.currentPetDemographic.formData.subSpecies && this.currentPetDemographic.formData.subSpecies.length)))
                    && (!this.currentModel.settings.showWalkInPetBreed || (this.currentPetDemographic.formData.petBreed && this.currentPetDemographic.formData.petBreed.length))
                    && (this.currentPetDemographic.formData.petApproxAge && this.currentPetDemographic.formData.petApproxAge.length)
                    && (!this.currentModel.settings.showWalkInPetGender || (this.currentPetDemographic.formData.sex && this.currentPetDemographic.formData.sex.length))
            },
            petDemographicIsValid() {
                return this.currentPetDemographic.isValid;
            },
            chiefComplaintIsValid() {
                if (this.currentModel.settings.showChiefComplaint
                    && (!this.currentChiefComplaint.isValid || !this.currentChiefComplaint.formData.chiefComplaint))
                    return false;
                if (this.showVisitType
                    && (!this.currentClientDepartments || !this.currentClientDepartments.formData.selectedDepartments || !(this.currentClientDepartments.formData.selectedDepartments > 0)))
                    return false;
                return true;
            },
            contactInfoIsValid() {
                return this.currentContactInfo.isValid && this.currentContactInfo.formData.optIn;
            },
            customQuestionsIsValid() {
                return this.currentCustomQuestions.isValid
                    && this.currentModel.settings.customQuestions
                    && this.currentModel.settings.customQuestions.length
                    && !this.currentModel.settings.customQuestions.some(x => x.questionAnswer === null || x.questionAnswer === undefined);
            },
            onlineValid() {
                if (this.$store.state.onlineMultipleBookings)
                    return this.$store.state.isOnlineValid;
                let input = this.$store.state.onlineInput;
                if (!input)
                    return false;
                if (this.$store.state.onlineOptionSelected === 'Phone') {
                    return /^(?:(1\-?)|(\+1 ?))?\(?\d{3}\)?[\-\.\s]?\d{3}[\-\.\s]?\d{4}$/.test(input) && /^(\d)(?!\1+$)\d{9}$/.test(this.unmask(input, '(###)-###-####'));
                }
                else {
                    return input.length === 13;
                }
            },
            ownerContactIsValid() {
                return this.currentContactInfo.isValid && this.currentContactInfo.formData.optIn && this.$store.state.ezyvet.contact;
            },
            nextStepDisabled() {
                const isEztvetFacility = this.currentModel.settings.isEzyvetFacility;
                if (isEztvetFacility) {
                    if (this.isOnline)
                        return !this.onlineValid;

                    if (this.currentStep === 1)
                        return !this.ownerContactIsValid;
                    else if (this.currentStep === 2)
                        return !this.demographicFormIsValid;
                    else if (this.currentStep === 3)
                        return !this.petDemographicFormIsValid;
                    else if (this.currentStep === 4) {
                        if (this.fourthStep === 'customQuestions') {
                            return !this.customQuestionsIsValid;
                        } else {
                            return !this.chiefComplaintIsValid;
                        }
                    } else if (this.currentStep === 5) {
                        return !this.chiefComplaintIsValid;
                    }
                } else {
                    const isAnimalFacility = this.currentModel.settings.isAnimalFacility;
                    if (this.isOnline)
                        return !this.onlineValid;
                    if (this.currentStep === this.lastStep)
                        return !this.contactInfoIsValid;
                    if (this.currentStep === 1)
                        return isAnimalFacility ? !this.petDemographicFormIsValid : !this.demographicFormIsValid;
                    if (this.currentStep === 2)
                        if (isAnimalFacility) return !this.demographicFormIsValid;
                        else {
                            if (this.secondStep === 'chiefComplaint' || this.secondStep === 'clientDepartments')
                                return !this.chiefComplaintIsValid;
                            if (this.secondStep === 'customQuestions')
                                return !this.customQuestionsIsValid;
                        }
                    if (this.currentStep === 3) {
                        if (isAnimalFacility) {
                            if (this.thirdStep === 'chiefComplaint' || this.thirdStep === 'clientDepartments')
                                return !this.chiefComplaintIsValid;
                            if (this.thirdStep === 'customQuestions')
                                return !this.customQuestionsIsValid;
                        }
                        else {
                            return !this.customQuestionsIsValid;
                        }
                    }
                    if (this.currentStep === 4)
                        return !this.customQuestionsIsValid;
                }
                   
                return false;
            },
            buttonClass() {
                if (this.$vuetify.breakpoint.smAndUp)
                    return 'v-size--large';
                return 'v-size--small';
            }
        },
        mounted() {
            this.$root.$off('formSubmitted');
            this.$root.$on('formSubmitted', () => {
                this.completeRegistration();
            })
        },
        methods: {
            completeRegistration() {
                if (this.isWalkin) {
                    this.$store.state.jotFormRedirectUrl = ''
                    const tt = this.buildWalkinReservationModel();
                    this.$store.dispatch('submitReservation', tt)
                        .then(response => {
                            if (response.data.isPatientMaxLimitExceeded === true) {
                                this.$store.state.isPatientMaxLimitExceeded = response.data.isPatientMaxLimitExceeded;
                                this.$store.state.messageHeadline = '';
                                this.$store.state.messageContent = this.currentModel.settings.localizedContent['walkin_max_patient_count_message'];
                                this.$router.push({ name: 'message', params: { clientId: this.clientId } });
                                return;
                            }
                            if (response.data.success && response.data.result.confirmationNumber) {
                                this.$store.state.reservationConfirmationNumber = response.data.result.confirmationNumber;
                                this.$store.state.jotFormRedirectUrl = response.data.result.jotformRedirectUrl;

                                if (response.data.result.hasNewTimeslot)
                                    this.$store.state.currentModel.availableTime.actualAvailableTimeDisplay =
                                        response.data.result.actualAvailableTimeDisplay;

                                if (this.$store.state.jotFormRedirectUrl) {
                                    this.$router.push({
                                        name: 'walkin_redirect',
                                        params: { clientId: this.clientId }
                                    });
                                }
                                else {
                                    this.$router.push({
                                        name: 'walkin_success',
                                        params: { clientId: this.clientId },
                                        query: { confirmationNumber: response.data.result.confirmationNumber }
                                    });
                                }
                                return;
                            }
                            if (response.data.result.isDivert && response.data.result.messageHeadline && response.data.result.messageContent) {
                                this.$store.state.messageHeadline = response.data.result.messageHeadline;
                                this.$store.state.messageContent = response.data.result.messageContent;
                                this.$router.push({ name: 'message', params: { clientId: this.clientId } });
                            }
                        }).catch(error => {
                            console.log(error);
                            if (this.parentClientId) {
                                this.$store.dispatch('resetWalkinForm');
                                this.$router.push({ name: 'lobby_root', params: { clientId: this.parentClientId } });
                            }
                            else {
                                this.$store.dispatch('resetWalkinForm', this.clientId);
                                this.$router.push({ name: 'lobby_root', params: { clientId: this.clientId } });
                            }
                        });
                }
                else {
                    let model = {
                        clientId: this.currentModel.settings.clientId,
                        inputType: this.$store.state.onlineOptionSelected,
                        inputValue: this.$store.state.onlineInput || this.$store.state.onlineInputTemp,
                        dob: this.$store.state.onlineDob
                    }
                    if (model.inputValue && model.inputType === 'Phone')
                        this.$store.state.onlineInputTemp = model.inputValue;
                    this.$store.dispatch('checkOnlineReservation', model).then(response => {
                        if (response.data.success) {
                            this.$store.dispatch('resetOnlineForm');
                            this.$router.push({
                                name: 'online_success',
                                params: { clientId: this.clientId }
                            });
                        } else {
                            if (response.data.statusCode === 409) {
                                this.$store.state.onlineMultipleBookings = true;
                            }
                            else {
                                if (this.$store.state.onlineFailedAttempts !== 3)
                                    this.$store.state.onlineFailedAttempts++;
                                this.$store.state.showOnlineFailedAttempts = true;
                            }
                        }
                    });
                }
            },
            buildWalkinReservationModel() {
                let userId = 0;
                if (this.$route.query && this.$route.query.UserId) {
                    userId = parseInt(this.$route.query.UserId);
                }
                let petReservationDetails = null;
                if (this.currentModel.settings.isAnimalFacility || this.isEzyvetFacility) {

                    let petAge = '';
                    if (this.currentModel.settings.petAgeInputType === 'FREE_TEXT')
                        petAge = `${this.currentPetDemographic.formData.petApproxAge} ${this.currentPetDemographic.formData.petApproxAgeType}`;

                    if (this.currentModel.settings.petAgeInputType === 'PICKLIST')
                        petAge = this.currentPetDemographic.formData.petApproxAge;

                    if (this.currentModel.settings.petAgeInputType === 'CALENDER_DATE')
                        petAge = moment(this.currentPetDemographic.formData.petApproxAge).format('MM/DD/YYYY');

                    petReservationDetails = {
                        petName: this.currentPetDemographic.formData.petName,
                        petGender: this.currentPetDemographic.formData.sex,
                        petBreed: this.currentPetDemographic.formData.petBreed,
                        petColor: this.currentPetDemographic.formData.petColor,
                        petSpecies: this.currentPetDemographic.formData.species,
                        petSubSpecies: this.currentPetDemographic.formData.subSpecies,
                        petApproximateAge: petAge,
                        animalId: this.currentPetDemographic.formData.animalId,
                    }
                }
                console.log(petReservationDetails);
                let selectedDepartments = [];
                if (this.currentClientDepartments.formData.selectedDepartments !== undefined) {
                    selectedDepartments.push(this.currentClientDepartments.formData.selectedDepartments);
                }                
                return {
                    clientId: this.currentModel.settings.clientId,
                    firstName: this.currentDemographic.formData.firstName,
                    lastName: this.currentDemographic.formData.lastName,
                    dob: this.currentDemographic.formData.dob,
                    sex: !this.currentModel.settings.showPatientGender ? "N/A" : this.currentDemographic.formData.sex,
                    phone: this.unmask(this.currentContactInfo.formData.phone, '(###)-###-####'),
                    smsOptIn: this.currentContactInfo.formData.optIn === '1' ? true : false,
                    email: this.currentContactInfo.formData.email,
                    selectedDepartments: selectedDepartments, //this.currentClientDepartments.formData.selectedDepartments,
                    customQuestions: this.currentModel.settings.customQuestions,
                    timeslotId: this.currentModel.availableTime.clientAvailableTimeId,
                    chiefComplaint: this.currentChiefComplaint.formData.chiefComplaint,
                    userId: userId,
                    lockGuid: this.currentModel.availableTime.lockGuid,
                    approxAge: this.currentDemographic.formData.approxAge,
                    petReservation: petReservationDetails,
                    contactId: this.currentDemographic.formData.contactId,
                };
            }
        }
  }
</script>

<style>
    #actions {
        background: white;
    }

        #actions .col {
            align-items: center;
        }

    .v-stepper {
        box-shadow: none;
    }

    .v-stepper__label {
        text-align: center !important;
        white-space: pre;
    }
</style>